import React, { Children, cloneElement, isValidElement } from 'react'
import styles from './styles.module.css'
import { cn, type UtilityClassNames } from '@s4l/utility-css'
import Tab, { type TabProps } from './Tab'

interface NavigationBarProps {
  children: React.ReactNode
  className?: UtilityClassNames
  onChange?: (index: number) => void
  cta?: React.ReactNode
  'aria-label'?: string
}

function NavigationBar({
  children,
  className,
  onChange,
  cta,
  'aria-label': ariaLabel = 'Tab sections',
}: Readonly<NavigationBarProps>) {
  const handleTabClick = (index: number) => {
    const childArray = Children.toArray(children)
    const child = childArray[index]

    if (isValidElement<TabProps>(child) && child.props.disabled) return

    onChange?.(index)
  }

  return (
    <nav className={cn(styles.navigationBar, className)} aria-label={ariaLabel}>
      <ul className={styles.scrollContainer}>
        {Children.map(children, (child, index) => {
          if (!isValidElement<TabProps>(child)) return child

          return cloneElement(child, {
            ...child.props,
            onClick: () => handleTabClick(index),
          })
        })}
      </ul>
      {cta && <div className={cn(styles.cta)}>{cta}</div>}
    </nav>
  )
}

NavigationBar.Tab = Tab

export default NavigationBar
